import React from "react";
import { Portfolio } from "../../../../../graphql/generated";
import useGridState from "../../../../../Providers/GridStateProvider/hooks/useGridState";
import IconLoader from "../../../../common/IconLoader";
import { sidebarMenus, sidebarSocialLinks } from "./constants";
import {
  HomeSidebarContainer,
  HomeSidebarLogo,
  HomeSidebarMenuItem,
  HomeSidebarMenuItemTooltip,
  HomeSidebarMenus,
  HomeSidebarSocialLinks,
} from "./styled";

interface Props {
  portfolioData: Omit<Portfolio, "createdBy">;
}

const HomeSidebar: React.FC<Props> = ({ portfolioData }) => {
  const {
    currentPageIndex,
    setCurrentPageIndex,
    setIsLoading,
    isLoading,
  } = useGridState();

  const getSocialMenuLinks = (type: string) => {
    if (type === "facebook") return portfolioData?.socialLinks?.facebook || "";
    if (type === "github") return portfolioData?.socialLinks?.github || "";
    if (type === "twitter") return portfolioData?.socialLinks?.twitter || "";
    if (type === "linkedin") return portfolioData?.socialLinks?.linkedin || "";
    if (type === "stack-overflow")
      return portfolioData?.socialLinks?.stackOverflow || "";
    else return "/";
  };

  return (
    <HomeSidebarContainer loading={isLoading ? 1 : 0}>
      {/* Sidebar => Logo */}
      <HomeSidebarLogo onClick={() => (window.location.href = "/")}>
        <span>S</span>
      </HomeSidebarLogo>

      {/* Sidebar => Menus */}
      <HomeSidebarMenus>
        {sidebarMenus.map((menu) => (
          <HomeSidebarMenuItem
            active={menu.index === currentPageIndex + 1 ? 1 : 0}
            key={menu.index}
            onClick={() => {
              setCurrentPageIndex(menu.index - 1);
              setIsLoading(true);
            }}
          >
            <IconLoader icon={menu.icon} size={30} />
            <HomeSidebarMenuItemTooltip>
              {menu.label}
            </HomeSidebarMenuItemTooltip>
          </HomeSidebarMenuItem>
        ))}
      </HomeSidebarMenus>

      {/* Sidebar => Social Links */}
      <HomeSidebarSocialLinks>
        {sidebarSocialLinks.map((menu) => (
          <li key={menu.index}>
            <a href={getSocialMenuLinks(menu.icon)} target="blank">
              <IconLoader icon={menu.icon} />
            </a>
          </li>
        ))}
      </HomeSidebarSocialLinks>
    </HomeSidebarContainer>
  );
};

export default HomeSidebar;
